import { format } from 'date-fns';

import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/user-oakley-subscriptions',
};

export const getColumns = () => [
  { id: 'userName', label: 'Name', align: 'left', nameForSort: 'user_name' },
  { id: 'userSurname', label: 'User Surname', align: 'center', nameForSort: 'user_surname' },
  { id: 'userEmail', label: 'User Email', align: 'center', nameForSort: 'user_email' },
  { id: 'type', label: 'Subscription Type', align: 'center', disableSort: true },
  { id: 'userPhoneNumber', label: 'User Phone Number', align: 'center', disableSort: true },
  { id: 'corporationName', label: 'Corporation Name', align: 'center', nameForSort: 'corporation_name' },
  { id: 'region', label: 'Region', align: 'center' },
  {
    id: 'subscriptionDate',
    label: 'Subscription date',
    customValue: (val) => format(new Date(val.subscriptionDate), 'dd MMMM yyyy pp'),
    align: 'center',
    nameForSort: 'subscription_date',
  },
  { id: 'subscriptionCost', label: 'Subscription Cost', align: 'center', nameForSort: 'subscription_cost' },
  { id: 'sunglasses', label: 'Sunglasses Selected', align: 'center', disableSort: true },
  { id: 'deliveryAddress', label: 'Delivery Address', align: 'center', disableSort: true },
];

export const getFilters = ({ searchByName, corporation, region, dateRange, options, status, type }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name, surname...',
    action: searchByName.change,
  },
  {
    id: 'dateRange',
    variant: 'dateTime',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'type',
    type: 'select',
    label: 'Type',
    value: type.value,
    action: type.change,
    items: ['all', 'oakleyGold', 'oakleySilver', 'oakleyBronze'],
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'corporate',
    type: 'autocomplete',
    label: 'Corporate',
    value: corporation.value,
    action: corporation.change,
    items: options?.corporates || [],
  },
  {
    id: 'status',
    type: 'select',
    label: 'Status',
    value: status.value,
    action: status.change,
    items: ['all', 'New', 'Renewed'],
  },
];
